import Router from "./tinyruby/router.js"

window.onload = () => {
  let root = document.querySelector("[data-root='talks']")

  if (!root) {
    // Stop here if there are no speakers
    return
  }

  let definedRouteEls = Array.from(root.querySelectorAll("[data-router-link]"))

  let definedRoutes = []
  for (let el of definedRouteEls) {
    let url = new URL(el.getAttribute("href"), document.location)
    definedRoutes.push({
      href: url.href,
    })
  }

  let routerInstance = Router("routerInstance", definedRoutes)

  let navigate = (href) => {
    let url = new URL(href, document.location)

    let routeInfo = routerInstance.routes.filter((r) => r.href === url.href)[0]
    if (routeInfo) {
      // Show the speaker dialog
      window.history.replaceState({}, "", routeInfo.href)

      // Close any currently open dialog
      let dialog = document.querySelector("dialog[open]")
      if (dialog) {
        dialog.close()
      }

      document.querySelector(`[data-dialog-id="${url.pathname}"]`)?.showModal()
    } else {
      console.debug("Unknown route", url)
    }
  }

  document.querySelectorAll("[data-close-dialog]").forEach((closeEl) => {
    closeEl.addEventListener("click", (event) => {
      event.preventDefault()
      let dialog = document.querySelector("dialog[open]")
      if (dialog) {
        dialog.close()
      }
      window.history.replaceState({}, "", event.currentTarget.href)
    })
  })

  // Attach event listeners to the links on the page
  document.querySelectorAll("[data-router-link]").forEach((el) => {
    el.addEventListener("click", (event) => {
      if (event.altKey || event.metaKey || event.ctrlKey || event.shiftKey) {
        // Allow normal behavior for modifier keys
        return
      }

      event.preventDefault()
      navigate(event.currentTarget.href)
    })
  })

  // Handle back/forward navigation
  window.addEventListener("popstate", (event) => {
    navigate(event.target.location.href)
  })
}
